import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle, Badge, Empty } from "@/components/app/ui";
import { useCurrency } from "@/context/CurrencyContext";
import { api, fmtMoney } from "@/lib/api";

export function AdminEnquiries() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/enquiries").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const setStatus = async (id, status) => { await api.patch(`/admin/enquiries/${id}`, { status }); toast.success("Updated"); load(); };
  return (
    <div data-testid="admin-enquiries-page">
      <PageTitle title="Enquiries" copy="Messages from the contact form. Notifications are emailed to contact@sliance.com." />
      {items.length === 0 && <Empty title="No enquiries yet" />}
      <div className="space-y-4">
        {items.map((e) => (
          <div key={e.id} className="card-box p-6" data-testid={`enquiry-${e.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div><div className="font-semibold">{e.name} · <a className="text-[#7c3aed]" href={`mailto:${e.email}`}>{e.email}</a></div>
                <div className="text-xs text-muted-foreground">{e.topic} · {e.company || "—"} · {e.phone || "—"} · {new Date(e.created_at).toLocaleString()}</div></div>
              <div className="flex items-center gap-2"><Badge s={e.status} />
                <Select value={e.status} onValueChange={(v) => setStatus(e.id, v)}><SelectTrigger className="w-36 h-9" data-testid={`enquiry-status-${e.id}`}><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="new">New</SelectItem><SelectItem value="in_progress">In progress</SelectItem><SelectItem value="resolved">Resolved</SelectItem></SelectContent></Select>
              </div>
            </div>
            <p className="mt-3 text-sm whitespace-pre-wrap">{e.message}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AdminPayments() {
  const { config } = useCurrency();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setItems(r.data)); }, []);
  return (
    <div data-testid="admin-payments-page">
      <PageTitle title="Payments" copy="All Razorpay orders across companies." />
      <div className="card-box overflow-x-auto">
        <Table data-testid="admin-payments-table">
          <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Company</TableHead><TableHead>Item</TableHead><TableHead>Amount</TableHead><TableHead>Mode</TableHead><TableHead>Status</TableHead><TableHead>Invoice</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.length === 0 && <TableRow><TableCell colSpan={7} className="text-center py-8 text-muted-foreground">No payments yet</TableCell></TableRow>}
            {items.map((p) => (
              <TableRow key={p.id}><TableCell className="text-xs">{new Date(p.created_at).toLocaleString()}</TableCell><TableCell>{p.company_name}</TableCell><TableCell>{p.item_name}</TableCell>
                <TableCell>{fmtMoney(p.total, p.currency, config?.symbols)}</TableCell><TableCell className="text-xs uppercase">{p.mode}</TableCell><TableCell><Badge s={p.status} /></TableCell><TableCell className="text-xs">{p.invoice_no || "—"}</TableCell></TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
